import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  timeout: 30000,
});

// Attach JWT token + browser marker to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('tp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  return config;
});

// Auto-retry once on network errors (mobile connection drops, timeouts)
api.interceptors.response.use(
  res => res,
  async err => {
    const config = err.config;
    // Retry once if no response received (network error, not a 4xx/5xx)
    if (!err.response && !config._retried) {
      config._retried = true;
      await new Promise(r => setTimeout(r, 1200));
      return api(config);
    }
    if (err.response?.status === 401) {
      // Don't redirect on login/auth endpoints — let the page handle the error itself
      const url = err.config?.url || '';
      const isAuthEndpoint = url.includes('/api/auth/');
      if (!isAuthEndpoint) {
        localStorage.removeItem('tp_token');
        localStorage.removeItem('tp_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
